const NoticeListIconWhite = () => (
  <div>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 2.66602V6.66602"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3333 2.66602V6.66602"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 11.3327V22.666C28 26.666 26 29.3327 21.3333 29.3327H10.6667C6 29.3327 4 26.666 4 22.666V11.3327C4 7.33268 6 4.66602 10.6667 4.66602H21.3333C26 4.66602 28 7.33268 28 11.3327Z"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 14.666H21.3333"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 21.334H16"
        stroke="#F7F9FD"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default NoticeListIconWhite;
